module.exports = __webpack_public_path__ + "static/media/info.b33b7b57.svg";